import * as React from 'react';
import { AggregationPanel } from './components/aggregation-panel';
import { AggregationState } from 'app/area/reports/containers/aggregation/types-store';
import { 
  useActionCreators, useLoadAggregateFieldOptionsEffect, 
  useLoadInitialDataEffect, useWorkingDefinitionAggregationState 
} from 'app/area/reports/containers/aggregation/hooks';
import { ReportCommonApi } from 'app/area/reports/types-api';

export interface AggregationContainerProps {
  orderNumber: string;
  translation: any;
  aggregateFieldState: AggregationState;
  fieldsToClearOnChange?: { target?: boolean; rollingAverage?: boolean; selections?: boolean };
}

export const AggregationContainerForApi = (api: ReportCommonApi) => ({
  translation,
  orderNumber,
  aggregateFieldState,
  fieldsToClearOnChange
}: AggregationContainerProps) => {

  const {
    fetching
  } = aggregateFieldState ?? {};

  const {
    loadAggregateFields,
    updateDefaultAggregateFields,
    setAggregateField,
    setAggregateFunction
  } = useActionCreators(api, fieldsToClearOnChange);

  const {
    selectedAggregationField,
    selectedAggregationFunction,
    selectedUomSet
  } = useWorkingDefinitionAggregationState();

  useLoadInitialDataEffect(api);

  useLoadAggregateFieldOptionsEffect(api);

  return <AggregationPanel
    orderNumber={orderNumber}
    fetching={fetching}
    data={aggregateFieldState}
    selectedAggregationField={selectedAggregationField}
    selectedAggregationFunction={selectedAggregationFunction}
    selectedUomSet={selectedUomSet}
    onLoadAggregateFields={loadAggregateFields}
    onUpdateDefaultAggregateFields={updateDefaultAggregateFields}
    onSelectAggregateField={setAggregateField}
    onSelectAggregateFunction={setAggregateFunction}
    translation={translation}
  />;
};
